class Burger {
  constructor(settings) {

    let flag, timer;
    this.options = Object.assign({
      container: 'header',
      onClickOutside: true,
      menuActiveClass: 'nav-active',
      menuOpener: '.nav-opener',
      menuDrop: '.nav-drop',
      toggleEvent: 'click',
      outsideClickEvent: 'click touchstart touchend pointerdown MSPointerDown'.split(' '),
      resizeClass: 'resize',
      breakpoint: 768
    }, settings)

    //if isset opener and container elements
    if (document.querySelector(this.options.menuOpener) && document.querySelector(this.options.container)) {
      this.page = document.querySelector('html');
      this.container = this.page.querySelector(this.options.container);
      this.opener = this.container.querySelectorAll(this.options.menuOpener);
      this.drop = this.container.querySelector(this.options.menuDrop);

      this._attachEvents();

    }
  }

  _attachEvents() {
    if (this._activateResizeHandler) {
      this._activateResizeHandler();
      this._activateResizeHandler = null;
    }

    this.opener.forEach(button => {
      button.addEventListener(this.options.toggleEvent, this._openerClickHandler.bind(this));
    });

   // this.opener.addEventListener(this.options.toggleEvent, this._openerClickHandler.bind(this));
  }

  _outsideClickHandler(e) {
    if (this._isOpened()) {
      if (!e.target.closest(this.options.menuOpener) && !e.target.closest(this.options.menuDrop)) {
        this._hide();
      }
    }
  }

  _openerClickHandler(e) {
    e.preventDefault();
    this._toggle();
  }

  _isOpened() {
    return this.container.classList.contains(this.options.menuActiveClass);
  }

  _show() {
    this.container.classList.add(this.options.menuActiveClass);
    if (this.options.onClickOutside) {
      this.options.outsideClickEvent.forEach((e) => {
          document.addEventListener(e, this._outsideClickHandler.bind(this));
        }
      )
    }

    if(this.options.menuOpener == '.js-menu-opener') {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }

  _hide() {
    this.container.classList.remove(this.options.menuActiveClass)
    if (this.options.onClickOutside) {
      this.options.outsideClickEvent.forEach((e) => {
          document.removeEventListener(e, this._outsideClickHandler.bind(this));
        }
      )
    }
  }

  _toggle() {
    if (this._isOpened()) {
      this._hide();
    } else {
      this._show();
    }
  }

  _activateResizeHandler() {
    this._removeClassHandler();
    window.addEventListener('resize', this._resizeHandler.bind(this));
  }

  _removeClassHandler() {
    this.flag = false;
    this.page.classList.remove(this.options.resizeClass);
  }

  _resizeHandler() {
    if (!this.flag) {
      this.flag = true;
      this.page.classList.add(this.options.resizeClass);
    }
    if (window.innerWidth > this.options.breakpoint && this._isOpened()) {
      this._hide();
    }
    clearTimeout(this.timer);
    this.timer = setTimeout(this._removeClassHandler.bind(this), 500);
  }
}

const burgerMenu = new Burger({
  container: 'body',
  menuActiveClass: 'menu-active',
  menuOpener: '.js-menu-opener',
  menuDrop: '.nav-drop'
});


const tabOpener = new Burger({
  container: '.tabset-wrap',
  menuActiveClass: 'tabset-active',
  menuOpener: '.tabset__opener',
  menuDrop: '.tabset'
});


const sizeOpener = new Burger({
  container: '.product-form__input-wrap',
  menuActiveClass: 'size-active',
  menuOpener: '.js-size-opener',
  menuDrop: '.product-form__input-drop'
});

const footerPopup = new Burger({
  container: 'body',
  menuActiveClass: 'footer-email-active',
  menuOpener: '.js-footer-popup-email__close',
  menuDrop: '.footer-popup__holder'
});


const shopPopup = new Burger({
  container: 'body',
  menuActiveClass: 'footer-shop-active',
  menuOpener: '.js-footer-popup-shop__close',
  menuDrop: '.footer-popup__holder'
});


let closeIcon = document.querySelector(".menu-drawer__navigation .js-menu-opener");
let links = document.querySelectorAll(".menu-drawer__close-link");

links.forEach(function (item) {
  item.addEventListener('click', function () {
    closeIcon.click();
  });
});

const mapPopup = new Burger({
  container: 'body',
  menuActiveClass: 'map-popup-active',
  menuOpener: '.js-button-open-map',
  menuDrop: '.popup-map'
});